import { gql } from '@apollo/client';

export const UpdateUserContactInfo = gql`
  mutation UpdateUserContactInfo($name: String!, $email: String!, $phone: String) {
    buyer {
      updateUserContactInfo(input: { name: $name, email: $email, phone: $phone }) {
        user {
          id
          email
          name
          phone
          learnMoreRequested
        }
      }
    }
  }
`;
